import { generateClient } from 'aws-amplify/api';

// Lazy client initialization to ensure Amplify is configured first
let client = null;
const getClient = () => {
  if (!client) {
    client = generateClient();
  }
  return client;
};

const addToWatchlistMutation = /* GraphQL */ `
  mutation AddToWatchlist($input: WatchlistInput!) {
    addToWatchlist(input: $input) {
      id
      userID
      movieID
      status
      createdAt
      updatedAt
    }
  }
`;

const removeFromWatchlistMutation = /* GraphQL */ `
  mutation RemoveFromWatchlist($id: ID!) {
    removeFromWatchlist(id: $id)
  }
`;

const updateMovieInteractionMutation = /* GraphQL */ `
  mutation UpdateMovieInteraction($input: UpdateMovieInteractionInput!) {
    updateMovieInteraction(input: $input) {
      id
      userID
      movieID
      watched
      notInterested
      userRating
      createdAt
      updatedAt
    }
  }
`;

const getUserQuery = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      watchlist {
        items {
          id
          movieID
          status
        }
      }
      watched {
        items {
          id
          movieID
          status
        }
        }
      }
    }
  }
`;

export const addToWatchlist = async (userId, movieId, status) => {
  const input = {
    userID: userId,
    movieID: movieId,
    status: status || 'WANT_TO_WATCH',
  };
  return await getClient().graphql({ query: addToWatchlistMutation, variables: { input } });
};

export const removeFromWatchlist = async (id) => {
  return await getClient().graphql({ query: removeFromWatchlistMutation, variables: { id } });
};

export const addToWatched = async (userId, movieId) => {
    const input = {
        userID: userId,
        movieID: movieId,
        watched: true,
    };
    return await getClient().graphql({ query: updateMovieInteractionMutation, variables: { input } });
}

export const removeFromWatched = async (userId, movieId) => {
    const input = {
        userID: userId,
        movieID: movieId,
        watched: false,
    };
    return await getClient().graphql({ query: updateMovieInteractionMutation, variables: { input } });
}

export const getUserWatchlist = async (userId) => {
    const result = await getClient().graphql({ query: getUserQuery, variables: { id: userId } });
    return result.data.getUser.watchlist.items;
}

export const getUserWatchedlist = async (userId) => {
    const result = await getClient().graphql({ query: getUserQuery, variables: { id: userId } });
    return result.data.getUser.watched.items;
}
